import SearchEmployeesDialog from "./SearchEmployeesDialog";

export default SearchEmployeesDialog;
